module.exports = __webpack_public_path__ + "static/second_user_image6-c89a346e8c65a02d02220513ebade688.jpg";